export const DEFAULT_ACCOUNT_BERRY = []
export const BERRIES_FAVORITES = []